module.exports = __webpack_public_path__ + "img/mastercard.c5b355c4.svg";